import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { fetch, handleErrors } from '../../../api';
import api from '../../../api/endpoints';

const prepareData = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      description: item.description,
      date: item.created_at,
      amount: item.amount_cents / 100
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getBillingTransactions({ payload: { signal, curr_page, type, dateFilter } }) {

  try {
    const { data } = yield call(fetch, {
      api: api.billing.credits.transactions,
      params: {
        page: curr_page,
        ...(type && { transaction_type: type }),
        ...(dateFilter.type && dateFilter.since && { date_from: dateFilter.since }),
        ...(dateFilter.type && dateFilter.until && { date_to: dateFilter.until })
      },
      signal
    });

    const preparedData = {
      results: prepareData(data.results),
      subtotal: data.subtotal_cents / 100,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous
    };

    yield put(actions.getBillingTransactionsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBillingTransactionsFailed,
      endpoint: api.billing.credits.transactions.url
    });
  }
}

export const getBillingTransactionsSaga = takeEvery(types.GET_BILLING_TRANSACTIONS_REQUEST, getBillingTransactions);


